'use client'

import { useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'

/**
 * Vraća prikaz na vrh pri svakoj promjeni rute.
 *
 * Next.js to obično radi sam, ali filter na `#a11y-root` (kontrastni režimi)
 * pravi novi containing block, pa ugrađeno pomjeranje zna da izostane.
 *
 * Skok je trenutan — bez animacije, da se ne kosi sa „smanji pokret".
 * Kod kretanja nazad/naprijed se ne miješamo: tu pregledač vraća raniju
 * poziciju i to je očekivano ponašanje.
 */
export function ScrollToTop() {
  const pathname = usePathname()
  const poppedRef = useRef(false)

  useEffect(() => {
    const onPopState = () => {
      poppedRef.current = true
    }
    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
  }, [])

  useEffect(() => {
    if (poppedRef.current) {
      poppedRef.current = false
      return
    }
    // Sidro u URL-u (npr. „Preskoči na sadržaj") ima prednost nad skokom na vrh.
    if (window.location.hash) return

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname])

  return null
}
